module.exports = __webpack_public_path__ + "img/四分相.4db7b75b.svg";